module.exports = __webpack_public_path__ + "static/media/welcome-nav.f00553a9.png";